import React from 'react';
import { useTranslations } from '../../../locales/useTranslations';
import { BiShield, BiLaptop, BiGitMerge, BiBlock } from 'react-icons/bi';

const ZeroTrustVpnBenefits = () => {
  const { t } = useTranslations();
  const items = [
    { icon: BiLaptop, text: t('managedServices_zeroTrustVpn_benefit1') },
    { icon: BiShield, text: t('managedServices_zeroTrustVpn_benefit2') },
    { icon: BiGitMerge, text: t('managedServices_zeroTrustVpn_benefit3') },
    { icon: BiBlock, text: t('managedServices_zeroTrustVpn_benefit4') },
  ];

  return (
    <section className="ms-section ms-section--benefits">
      <div className="container">
        <div className="ms-section-header ms-section-header--center">
          <span className="ms-section__badge">{t('managedServices_zeroTrustVpn_benefits_badge')}</span>
          <h2 className="ms-section__title">{t('managedServices_zeroTrustVpn_benefits_title')}</h2>
          <p className="ms-section__lead ms-section__lead--center">
            {t('managedServices_zeroTrustVpn_benefits_intro')}
          </p>
        </div>
        <div className="row">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="col-lg-6 col-md-6 mb-4">
                <div className="ms-benefit-card">
                  <div className="ms-benefit-card__icon">
                    <Icon />
                  </div>
                  <p>{item.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ZeroTrustVpnBenefits;
